import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingSection = ({ onTopicClick }) => {
  const trendingTopics = [
    {
      id: 1,
      name: 'Медитация и осознанность',
      count: 1247,
      trend: 'up',
      icon: 'Sparkles',
      color: 'text-accent'
    },
    {
      id: 2,
      name: 'Философские беседы',
      count: 892,
      trend: 'up',
      icon: 'BookOpen',
      color: 'text-primary'
    },
    {
      id: 3,
      name: 'Путешествия по миру',
      count: 756,
      trend: 'up',
      icon: 'Plane',
      color: 'text-secondary'
    },
    {
      id: 4,
      name: 'Музыка и творчество',
      count: 634,
      trend: 'stable',
      icon: 'Music',
      color: 'text-success'
    },
    {
      id: 5,
      name: 'Культура и искусство',
      count: 521,
      trend: 'down',
      icon: 'Palette',
      color: 'text-warning'
    }
  ];

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up':
        return { name: 'TrendingUp', color: 'var(--color-success)' };
      case 'down':
        return { name: 'TrendingDown', color: 'var(--color-error)' };
      default:
        return { name: 'Minus', color: 'var(--color-muted-foreground)' };
    }
  };

  return (
    <div className="trending-section bg-card border border-border rounded-lg p-6">
      <div className="section-header flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg font-heading font-semibold text-foreground">
            Популярные темы
          </h2>
          <p className="text-sm text-muted-foreground">
            Что слушают сейчас
          </p>
        </div>
      </div>
      <ul className="trending-list space-y-3">
        {trendingTopics?.map((topic, index) => {
          const trendIcon = getTrendIcon(topic?.trend);
          return (
            <li key={topic?.id}>
              <button
                onClick={() => onTopicClick(topic?.name)}
                className="trending-item w-full flex items-center gap-4 p-3 rounded-lg hover:bg-muted transition-all duration-200 group"
              >
                <span className="item-rank text-lg font-heading font-bold text-muted-foreground group-hover:text-primary transition-colors duration-200">
                  {index + 1}
                </span>

                <div className={`item-icon w-10 h-10 rounded-lg bg-muted flex items-center justify-center ${topic?.color}`}>
                  <Icon name={topic?.icon} size={20} color="currentColor" />
                </div>

                <div className="item-content flex-1 text-left min-w-0">
                  <h3 className="text-sm font-heading font-semibold text-foreground truncate">
                    {topic?.name}
                  </h3>
                  <p className="text-xs text-muted-foreground">
                    {topic?.count?.toLocaleString('ru-RU')} эфиров
                  </p>
                </div>

                <div className="item-trend flex items-center gap-1">
                  <Icon name={trendIcon?.name} size={16} color={trendIcon?.color} />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TrendingSection;